exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header-cart__count[data-v-51562038]{position:absolute;background-color:#d10043;color:#fff;width:1rem;height:1rem;display:inline-block;font-size:.7rem;text-align:center;line-height:1.1rem;font-weight:700;border-radius:50%;top:20px;right:5px}", ""]);

// exports
